(() => {
  const COUNT_SELECTOR = '[data-visible-card-count]';
  const GRID_SELECTOR = '#product-grid';
  const CONTAINER_SELECTOR = '#ProductGridContainer';
  let animationFrame;
  let observer;

  const isVisible = element => {
    if (!element || !element.isConnected || element.hidden) return false;
    if (element.classList.contains('hidden')) return false;

    const styles = window.getComputedStyle(element);

    if (styles.display === 'none' || styles.visibility === 'hidden') {
      return false;
    }

    return Boolean(
      element.offsetWidth ||
      element.offsetHeight ||
      element.getClientRects().length
    );
  };

  const formatCount = (count, countElement) => {
    const template =
      count === 1
        ? countElement.dataset.countTemplateOne
        : countElement.dataset.countTemplateOther;

    if (template) {
      return template.replace(/\[count\]/g, count);
    }

    return countElement.textContent.trim().replace(/^\d+/, count);
  };

  const updateCount = () => {
    const grid = document.querySelector(GRID_SELECTOR);
    const countElement = document.querySelector(COUNT_SELECTOR);

    if (!grid || !countElement) return;

    const visibleCards = Array.from(
      grid.querySelectorAll('card-product')
    ).filter(isVisible);

    countElement.textContent = formatCount(visibleCards.length, countElement);
  };

  const scheduleUpdate = () => {
    window.cancelAnimationFrame(animationFrame);
    animationFrame = window.requestAnimationFrame(updateCount);
  };

  const observeCollectionGrid = () => {
    const container = document.querySelector(CONTAINER_SELECTOR);

    if (!container) return;

    if (observer) observer.disconnect();

    observer = new MutationObserver(scheduleUpdate);
    observer.observe(container, {
      attributes: true,
      attributeFilter: ['class', 'hidden', 'style'],
      childList: true,
      subtree: true
    });

    scheduleUpdate();
  };

  const scheduleDelayedUpdates = () => {
    [100, 500, 1000, 2000, 4000].forEach(delay => {
      window.setTimeout(scheduleUpdate, delay);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCollectionGrid);
  } else {
    observeCollectionGrid();
  }

  window.addEventListener('load', () => {
    observeCollectionGrid();
    scheduleDelayedUpdates();
  });
  window.addEventListener('shopify:section:load', observeCollectionGrid);
})();
